export default __webpack_public_path__ + "static/media/light.c7189e95.svg";